import React from "react"
import {ThemeProvider} from "@material-ui/core/styles"

// Theme
import createModernTheme from "./createModernTheme"

// Context
import {useUiSkin} from "../../modules/ui-skin/context/UiSkinContext"

/**
 * Supplies the Modern MUI theme (palette.type + `theme.modern` tokens).
 *
 * Mounted only inside LayoutSwitch's Modern branch, which is what guarantees
 * the Classic tree can never resolve a dark palette or a `theme.modern` value.
 */
export default function ModernThemeProvider(props: {children: React.ReactNode}) {
    const {theme} = useUiSkin();

    // createMuiTheme is not cheap and this would otherwise re-run on every
    // render of every Modern page
    const muiTheme = React.useMemo(() => createModernTheme(theme), [theme]);

    return (
        <ThemeProvider theme={muiTheme}>
            {props.children}
        </ThemeProvider>
    )
}
